export default class Animate {
    /**
     * Animations to play.
     * @param animationDelay
     * @param animationDuration
     * @param animationName
     * @param el
     */
    constructor({animationDelay, animationDuration, animationName, el, callback}) {
        this.options = {
            el: el ? el : null,
            animationName: animationName ? animationName :'fadeIn',
            animationDuration: animationDuration ? animationDuration : 300,
            animationDelay: animationDelay ? animationDelay : 0,
            callback: callback ? callback : function() {

            },
        };

        this.delayTimer = null;
        this.runTimer = null;

        if(!this.options.el) {
            throw new Error("Animate.js - No element passed.")
        }

        this.options.el.animation = this;
        this.playing = false;
    }

    play() {
        this.playing = true;
        this.delay();
    }

    delay() {
        if(this.delayTimer === null && this.playing) {
            window.setTimeout(() => {
                if(this.playing) {
                    //when the animation delay has ended start the animation.
                    this.runAnimation()
                } else {
                    this.delayTimer = null;
                    this.runTimer = null;
                }
            }, this.options.animationDelay);
        }
    }

    runAnimation() {
        if(this.runTimer === null && this.playing) {
            this.options.el.classList.add(this.options.animationName);
            window.setTimeout(() => {
                if(this.playing) {
                    this.finished();
                } else {
                    this.delayTimer = null;
                    this.runTimer = null;
                }
            }, this.options.animationDuration);
        }
    }

    finished() {
        // this.options.el.classList.remove(this.options.animationName);
        this.options.callback();
        this.delayTimer = null;
        this.runTimer = null;
    }

    cancel() {
        this.playing = false;
        this.options.el.classList.remove(this.options.animationName);
        this.delayTimer = null;
        this.runTimer = null;
    }
}